const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@views/login"),
  },
  {
    path: "/user",
    component: () => import("@views/user"),
    meta: {
      requiresUserToBeLoggedIn: true,
    },
    children: [
      {
        path: "",
        name: "user",
        redirect: "companies",
      },
      {
        path: "companies",
        name: "user-companies",
        component: () => import("@views/user/companies"),
      },
      {
        path: "bureaus",
        name: "user-bureaus",
        component: () => import("@views/user/bureaus"),
      },
    ],
  },
  {
    path: "/todo",
    component: () => import("@views/todo"),
    meta: {
      requiresUserToBeLoggedIn: true,
    },
    name: "todo",
  },
  {
    path: "/newvalidation",
    component: () => import("@views/newvalidation"),
    meta: {
      requiresUserToBeLoggedIn: true,
    },
    name: "newvalidation",
  },
];

export default routes;
